import { render, staticRenderFns } from "./HouseList.vue?vue&type=template&id=2d189f09&scoped=true"
import script from "./HouseList.vue?vue&type=script&lang=js"
export * from "./HouseList.vue?vue&type=script&lang=js"
import style0 from "./HouseList.vue?vue&type=style&index=0&id=2d189f09&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d189f09",
  null
  
)

export default component.exports